// Original vector marks; independent of third-party artwork and system fonts.
export const DRAWING_ICONS=[
 {id:'star',label:'Star',path:'M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8Z',color:'#eab308'},
 {id:'check',label:'Check',path:'M3 12L9 18L21 5L18 3L9 13L6 10Z',color:'#22c55e'},
 {id:'warning',label:'Warning',path:'M12 2L23 22H1Z M11 8H13V15H11Z M11 17H13V19H11Z',color:'#f59e0b'},
 {id:'idea',label:'Idea',path:'M8 17C8 12 3 12 5 6C7-1 20 0 20 8C20 12 16 13 16 17Z M8 20H16 M10 23H14',color:'#eab308'},
 {id:'up',label:'Up',path:'M12 2L23 13H16V23H8V13H1Z',color:'#22c55e'},
 {id:'down',label:'Down',path:'M8 1H16V11H23L12 22L1 11H8Z',color:'#ef4444'},
 {id:'flag',label:'Flag',path:'M4 23V2H20L16 7L20 12H4',color:'#3b82f6'},
 {id:'rocket',label:'Rocket',path:'M5 15C5 8 12 1 22 2C23 12 16 19 9 19Z M5 13L1 15V21L8 18 M11 19L9 24H15L18 18 M16 5A3 3 0 1 1 16 11A3 3 0 1 1 16 5 M3 22L1 24',color:'#a855f7'},
];
export const DRAWING_EMOJI=['🙂','😀','😎','🤔','👀','👍','👎','💡','🔥','🚀','📈','📉','💰','🎯','⚠️','✅','❌','⭐','🐂','🐻','🛑','📌','⏳','🏆'];
